sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var ProjectUsers = BlockBase.extend("com.reply.leaviosa.blocks.users.ProjectUsers", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.users.ProjectUsers",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.users.ProjectUsers",
					type: ViewType.XML
				}
			}
		}
	});

	return ProjectUsers;
});